export const createFunctionButton = {
  title: 'Create function',
  subtitle:
    "An empty function will be created, don't forget to populate its definition before trying out your agent.",
};
